module.exports = __webpack_public_path__ + "img/Icon@3x.fcd21eb3.svg";